import * as React from 'react';
import { styled } from 'styled-components';

import { tk } from '@sunwebgroup/ui-components';

import { SelectedFiltersChips } from './SelectedFiltersChips';
import { Filters } from './Filters';

const Wrapper = styled.div`
  display: none;
  background: ${tk('color_semantic_bg')};
  flex: 0 0 400px;
  align-self: start;
  padding: ${tk('spacing_2xl')} ${tk('spacing_xl')} ${tk('spacing_2xl')} ${tk('spacing_4xl')};
  min-width: 0;

  @media ${tk('mq_desktop_lg')} {
    display: initial;
  }
`;

const DesktopOnly = styled.div`
  display: none;
  @media ${tk('mq_desktop_lg')} {
    display: initial;
  }
`;
export function SideBar() {
  return (
    <Wrapper>
      <DesktopOnly>
        <SelectedFiltersChips withResetButton />
      </DesktopOnly>
      <Filters />
    </Wrapper>
  );
}
